import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import AvailabilityForm from './pages/Availability';
import LoginPage from './pages/Login';
import RegisterPage from './pages/Registration';
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import LandingPage from './pages/LandingPage';
import PrivateRoute from './components/PrivateRoute'; 
import ScrollToTop from './components/ScrollToTop';
import SubscribePage from './pages/SubscribePage';
import Success from './pages/Success';
import Cancel from './pages/Cancel';

function App() {
  return (
    <div className="app-container">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/subscribe/:userId" element={<SubscribePage />} />
        <Route path="/success" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />

        
        <Route
          path="/availability"
          element={
            <PrivateRoute>
              <AvailabilityForm />
            </PrivateRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
